import { NavigateNext } from "@mui/icons-material";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router";
import { useMemo } from "react";
import { ROUTE_TITLES, SPECIAL_ROUTES } from "../../router/routeConfig";

const matchSpecialRoute = (pathname, specialRoutes) => {
  for (const [routePattern, breadcrumb] of Object.entries(specialRoutes)) {
    const regexPattern = `^${routePattern.replace(/:[^/]+/g, "[^/]+")}$`;
    const regex = new RegExp(regexPattern);
    if (regex.test(pathname)) {
      return breadcrumb;
    }
  }
  return null;
};

const BreadcrumbNav = ({ type, company_name, fieldName, instrument }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const routeTitles = ROUTE_TITLES(type, company_name);
  const specialRoutes = SPECIAL_ROUTES(
    type,
    company_name,
    fieldName,
    instrument
  );

  const pathnames = location.pathname.split("/").filter((x) => x);

  const breadcrumbs = useMemo(() => {
    let crumbs = [];

    const matchedSpecial = matchSpecialRoute(location.pathname, specialRoutes);
    if (matchedSpecial) {
      crumbs = matchedSpecial;
    } else {
      pathnames.forEach((_, index) => {
        const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;

        if (routeTitles[routeTo]) {
          crumbs.push({
            path: routeTo,
            title: routeTitles[routeTo] || "Pagina non trovata",
          });
        }
      });
    }

    return crumbs;
  }, [location.pathname, pathnames, routeTitles, specialRoutes]);

  return (
    <Breadcrumbs
      separator={<NavigateNext fontSize="small" />}
      aria-label="breadcrumbs"
    >
      {breadcrumbs.map((crumb, index) =>
        index === breadcrumbs.length - 1 ? (
          <Typography
            key={crumb.path}
            sx={{ fontSize: "20px", fontWeight: 600, color: "text.primary" }}
          >
            {crumb.title}
          </Typography>
        ) : (
          <Link
            key={crumb.path}
            onClick={() => navigate(crumb.path)}
            sx={{
              cursor: "pointer",
              fontSize: "20px",
              fontWeight: 600,
              textDecoration: "none",
              color: "inherit",
            }}
          >
            {crumb.title}
          </Link>
        )
      )}
    </Breadcrumbs>
  );
};

export default BreadcrumbNav;
